<template>
    <div class="header-page">
         <div class="header-left">
             <el-avatar shape="square" style="width:72px" :src="srcUrl"></el-avatar>
             <span style="margin-left:15px;">智绿车管家</span>
         </div>
         <div class="header-right">
            <div class="account-name">欢迎，{{company}}</div>
            <div class="account-name">{{nickname}}</div>
            <el-link type="primary" :underline="false" @click="onLoginOut">退出</el-link>
         </div>
    </div>
</template>
<script>
import srcUrl from '@/assets/logo.png'
import {clearCache,getCache} from '@/utils'

export default {
    name:"headerPage",
    data(){
        return {
            srcUrl,
            company:getCache('company'),
            nickname:getCache('nickname')
        }
    },
    methods:{
        onLoginOut(){
            this.$confirm('您确定是否要退出登录?', '系统提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                clearCache()
                this.$router.push({path:"/login"})
            }).catch(() => {
                   
            });
        }
    }
}
</script>
<style scoped>
.header-page{
    height: 56px;
    border-bottom:1px solid #ebebeb;
    box-sizing: border-box;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
}
.header-left{
    display: flex;
    font-family: AlibabaPuHuiTi;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0em;
    align-items: center;
}
.header-right{
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 14px;
}
.account-name{
    cursor: pointer;
    margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue